import { Calculate } from "../components/Calculate";

export function CalculatePage(){
    return <>
        <Calculate/>
    </>
}